import type { common as ruCommon } from '../ru/common';

export const common: typeof ruCommon = {
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    close: 'Close',
    edit: 'Edit',
    create: 'Create',
    add: 'Add',
    apply: 'Apply',
    reset: 'Reset',
    retry: 'Retry',
    search: 'Search',
    confirm: 'Confirm',
    copy: 'Copy',
    back: 'Back',
    toHome: 'Go to home'
  },
  states: {
    loading: 'Loading…',
    saving: 'Saving…',
    noData: 'No data',
    copied: 'Copied',
    error: 'Error'
  },
  yes: 'Yes',
  no: 'No',
  all: 'All',
  sidebar: {
    profileTitle: 'My profile',
    online: 'Online',
    onlineUsers: (authenticated: number, guests: number) => `Online: ${authenticated} signed in, ${guests} guests`,
    loginWithSteam: 'Sign in with Steam',
    loginConsentPrefix: 'By signing in, you agree to the',
    loginConsentLink: 'Personal Data Processing Policy',
    mainNavigation: 'Main navigation',
    logout: 'Log out',
    privacyPolicy: 'Personal Data Processing Policy',
    languageSwitcher: 'Interface language',
    adminMenu: 'Admin menu',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    profile: 'Profile',
    profileMenu: 'Profile menu',
    siteNavigation: 'Site navigation'
  }
};
